import { StyledOcticon as PrimerStyledOcticon, StyledOcticonProps as PrimerStyledOcticonProps } from '@primer/react';

type Props = {} & PrimerStyledOcticonProps;

const StyledOcticon = ({ ...props }: Props) => <PrimerStyledOcticon {...props} />;

export default StyledOcticon;
export type { Props as StyledOcticonProps };
